// Mirrors server/frontBackDesign.js.
export const DESIGN_PLACEMENTS = [
  { id: 'front', label: 'Front' },
  { id: 'back', label: 'Back' },
  { id: 'both', label: 'Both' },
  { id: 'none', label: 'No design (plain garment)' }
]
export const PLACEMENT_LABELS = {
  front: 'Front only',
  back: 'Back only',
  both: 'Front and back',
  none: 'None (plain garment)'
}
export const FRONT_BACK_LABEL = 'Left: front. Right: back.'
export const BACK_PLAIN_LABEL = 'Back: plain.'
export const FRONT_PLAIN_LABEL = 'Front: plain.'
export const PLAIN_GARMENT_SUMMARY = `Design placement: ${PLACEMENT_LABELS.none}. ${FRONT_PLAIN_LABEL} ${BACK_PLAIN_LABEL}`
export const DESCRIPTION_MAX = 500
export const BACK_DESCRIPTION_REQUIRED = 'Describe the back design.'
export const PLACEMENT_REQUIRED = 'Choose where your design goes: Front, Back, Both, or No design.'
export const BACK_MENTION_HINT = 'Looks like you mentioned the back. Switch to Both?'
export const DESIGN_MENTION_HINT = 'Looks like you want a design. Pick Front, Back, or Both?'

const DESIGN_MENTIONS = /\b(?:prints?|printed|printing|screen\s*print(?:ed)?|graphics?|logos?)\b/i

/** True when free text asks for a print, graphic, or logo. Embroidery and patches do not count. */
export function mentionsDesign(...texts) {
  return DESIGN_MENTIONS.test(texts.filter((t) => typeof t === 'string').join(' '))
}

const BACK_MENTIONS = [
  /\b(?:on|across|along|down|onto|at|to)\s+(?:the\s+)?back\b(?!\s+pockets?\b)/i,
  /\bback\s+(?:print|graphic|design|logo|text|artwork|art|image|embroidery|patch|panel|side|piece)s?\b/i,
  /\b(?:back|rear)print(?:ed)?\b/i,
  /\bthe\s+back\s+of\b/i,
  /\b(?:printed|embroidered|stitched)\s+on\s+(?:the\s+)?back\b/i
]

/** True when free text talks about a design on the back of the garment. */
export function mentionsBack(...texts) {
  const text = texts.filter((t) => typeof t === 'string').join(' ')
  return BACK_MENTIONS.some((pattern) => pattern.test(text))
}

export function placementOf(design) {
  if (['front', 'back', 'both', 'none'].includes(design?.designPlacement)) return design.designPlacement
  return design?.backDesign === true ? 'both' : 'front'
}

export function isFrontBackDesign(design) {
  return design?.backDesign === true || design?.imageLayout === 'front_back'
}
